import React from "react";
import { noop } from "@common/helpers/function";
import { TransactionMatchType } from "@common/types/transactionMatchType";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

interface Option {
    label: string;
    value: TransactionMatchType;
}

// Invoice/bill matching is available on every entity, not just accrual-ledger
// ones: cash-basis document matching
// (AccrualReviewCashBasisApproveInternalService.approveWithDocumentMatch)
// writes the same accrual_match rows an accrual-ledger match does (see
// applyMatchedFilters on the backend). The filter must therefore always offer
// every option — gating Invoice/Bill behind an accrual-ledger check
// previously hid a real, queryable match state.
const OPTIONS: Option[] = [
    {
        label: "Transaction match",
        value: TransactionMatchType.TRANSACTION,
    },
    {
        label: "Invoice match",
        value: TransactionMatchType.INVOICE,
    },
    {
        label: "Bill match",
        value: TransactionMatchType.BILL,
    },
    {
        label: "No match",
        value: TransactionMatchType.NONE,
    },
    {
        label: "Suggested invoice match",
        value: TransactionMatchType.SUGGESTED_INVOICE,
    },
    {
        label: "Suggested bill match",
        value: TransactionMatchType.SUGGESTED_BILL,
    },
];

const options: FilterMultiselectOption[] = OPTIONS.map((opt) => ({
    value: opt.value,
    label: opt.label,
    searchableLabel: opt.value,
}));

export const MatchedFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <div className={styles.filter}>
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={filters.matchTypes ?? []}
            onChange={(val) => {
                onChange({
                    matchTypes:
                        val.length > 0
                            ? (val as TransactionMatchType[])
                            : undefined,
                });
            }}
            name="matchTypes"
            onBlur={noop}
        />
    </div>
);
